module.exports = __webpack_public_path__ + "img/2.fc61819a.png";